module.exports = __webpack_public_path__ + "img/badge_gray_cap-academicplan.2b154868.svg";